import { Component, Prop, Vue } from "vue-property-decorator";

import { mixins } from "vue-class-component";
import EndpointData from "./data-mixin";

@Component({
    components: {},
})
export default class QueryEndpointData extends mixins(EndpointData) {
    // Supply chain leg config prop.
    @Prop() protected config!: any;

    // Display props.
    @Prop() protected commodity!: string;
    @Prop() protected metric!: any;
    @Prop() protected spatial_type!: any;
    @Prop() protected applied_border_crossings!: number | null;
    @Prop({ default: () => [] }) protected spatial_selection!: string[];
    @Prop({ default: () => [] }) protected applied_spatial_selection!: string[];
    @Prop() protected supply_chain_leg!: string;
    @Prop() protected applied_supply_chain_leg!: string;
    @Prop() protected metric_type?: any;
    @Prop() protected border_crossings_chart_metric?: string | null;
    @Prop() spatialBorderCrossing!: boolean;

    get regions() {
        // Prepend the direction into the region selected.
        return this.config.direction + "_" + this.spatial_type.value;
    }

    get updateRequired(): string {
        // A getter for inheritortors to watch if the data requires updating.
        var spatialKey = this.applied_spatial_selection
            .slice() // don't mutate original
            .sort() // stable order
            .join(",");
        return [
            this.commodity,
            this.applied_border_crossings ?? "none",
            spatialKey,
            this.applied_supply_chain_leg,
            this.metric.value,
            this.spatial_type.value,
        ].join(" | ");
    }

    supply_chain_leg_direction(supply_chain_leg: string) {
        return supply_chain_leg !== "consumption_exports" ? "orig" : "dest";
    }

    define_metric(map_id: string, metric: string): string {
        if (this.border_crossings_chart_metric) {
            return this.border_crossings_chart_metric;
        }

        if (metric !== "tonnes") {
            if (
                ["production_imports", "processing", "distribution"].includes(
                    map_id,
                )
            ) {
                return "to_" + metric;
            } else if (map_id === "consumption_exports") {
                return "from_" + metric;
            }
        }
        return metric;
    }

    getQueryParams() {
        // Build the endpoint url based upon SCE filter values.
        var queryParams: any = {};

        queryParams["dataset"] = this.dataset;
        queryParams["commodity"] = this.commodity;

        if (this.metric_type) {
            queryParams["metric_type"] = this.metric_type;
        }

        queryParams["metric"] = this.define_metric(
            this.config.map_id,
            this.metric.value,
        );

        if (this.applied_border_crossings != null) {
            queryParams["border_crossings"] = this.applied_border_crossings;
        }
        queryParams["regions"] = this.regions;
        queryParams["map_id"] = this.config.map_id;

        if (this.applied_spatial_selection.length > 0) {
            // Orig/dest regions should be based on a supply chain leg selected
            queryParams[
                this.supply_chain_leg_direction(this.applied_supply_chain_leg) +
                    "_region"
            ] = this.applied_spatial_selection;
            queryParams["supply_chain_leg"] = this.applied_supply_chain_leg;
        }

        if (
            this.spatialBorderCrossing &&
            this.applied_spatial_selection.length === 0
        ) {
            queryParams["supply_chain_leg"] = this.applied_supply_chain_leg;
        }

        return queryParams;
    }

    numberWithCommas(x: any): string {
        return Number(x).toLocaleString();
    }
}
